import React, {useState} from 'react'
import ParentMenuHeader from './ParentMenuHeader'
import StandaloneMenuHeader from './StandaloneMenuHeader'

import {Menu} from './types'
import styles from './styles.module.css'

type Props = {
  menu: Menu
}

const NavBar: React.FC<Props> = ({menu}) => {
  const [open, setOpen] = useState<number[]>([])
  return (
    <nav>
      <ul className={styles.mainNav} data-testid="app-nav">
        {menu.map((menuHeader, index) => {
          if (menuHeader.hidden || menuHeader.children?.every((c) => c.hidden))
            return
          if (menuHeader.children) {
            const current = menuHeader.children.findIndex(
              (item) => window.location.pathname === item.url
            )
            return (
              <ParentMenuHeader
                header={menuHeader}
                current={current === -1 ? false : current}
                open={open.includes(index)}
                key={menuHeader.label}
                onOpen={() =>
                  setOpen((open) =>
                    open.includes(index) ? open : open.concat(index)
                  )
                }
                onClose={() =>
                  setOpen((open) => open.filter((o) => o !== index))
                }
              />
            )
          } else {
            const current = window.location.pathname === menuHeader.url
            return (
              <StandaloneMenuHeader
                header={menuHeader}
                current={current}
                key={menuHeader.label}
              />
            )
          }
        })}
      </ul>
    </nav>
  )
}

export default NavBar
